import { useEffect, useState } from 'react'
import type { AuthSession } from '../../adapters/auth/authPort'
import { authAdapter } from '../../adapters/auth/supabaseAuthAdapter'

export function useAuthSession() {
  const [session, setSession] = useState<AuthSession | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    authAdapter.getSession()
      .then(value => active && setSession(value))
      .finally(() => active && setLoading(false))

    const unsubscribe = authAdapter.onAuthStateChange(value => {
      setSession(value)
      setLoading(false)
    })

    return () => {
      active = false
      unsubscribe()
    }
  }, [])

  return { session, loading }
}
